import axios from './axiosInstance';

export const organizationsList = async () => {
  const response = await axios.get("/club_api/organizations");
  return response.data;
};

export const organizationsClubs = async () => {
    const response = await axios.get("/club_api/organization_clubs");
    return response.data;
};

export const assignOrganizationClubGroup = async (clubs_organization_id, club_group_id, position) => {
  const response = await axios.put(`/club_api/organization_clubs/${clubs_organization_id}`, { club_group_id, position });
  return response.data;
};

export const getClubGroups = async (params = {}) => {
  const response = await axios.get("/club_api/club_groups", { params });
  return response.data;
};

export const createClubGroup = async (groupData) => {
  const response = await axios.post("/club_api/club_groups",{ group: groupData });
  return response.data;
};

export const updateClubGroup = async (id, groupData) => {
  const response = await axios.put(`/club_api/club_groups/${id}`, { group: groupData });
  return response.data;
};

export const deleteClubGroup = async (id) => {
  const response = await axios.delete(`/club_api/club_groups/${id}`);
  return response.data;
};



export const organizationInvitesList = async (params = {}) => {
  const response = await axios.get("/club_api/organization_invites/", { params});
  return response.data;
};

export const organizationInvite = async (user) => {
  const response = await axios.post("/club_api/organization_invites/", { user });
  return response.data;
};

export const removeOrganizationInvite = async (id) => {
  const response = await axios.delete(`/club_api/organization_invites/${id}`);
  return response.data;
};

export const organizationMembersList = async (params = {}) => {
  const response = await axios.get("/club_api/organization_members/", { params });
  return response.data;
};

export const removeOrganizationMember = async (id) => {
  const response = await axios.delete(`/club_api/organization_members/${id}`);
  return response.data;
};
